import _ from 'lodash'

import { TREND, POSITIVE, NEGATIVE } from './constants'

/**
 * Returns trend based on input value.
 * Trends are specified in TREND constant
 * @param {number} value Input number used to get trend
 * @param {boolean} flipped Flips returned arrow
 * @returns {string} Trend value
 */
export const getArrowTrend = (value, flipped) => {
    if (_.isNaN(value) || _.isNil(value)) return null
    const inputValue = _.toNumber(value)

    if (inputValue < -50) return `${TREND.STEEP_DECREASE}${!flipped ? NEGATIVE : POSITIVE}`
    if (_.inRange(inputValue, -51, 0)) return `${TREND.DECREASE}${!flipped ? NEGATIVE : POSITIVE}`
    if (inputValue === 0) return TREND.STAGNATION
    if (_.inRange(inputValue, 0, 51)) return `${TREND.INCREASE}${!flipped ? POSITIVE : NEGATIVE}`
    if (inputValue > 50) return `${TREND.STEEP_INCREASE}${!flipped ? POSITIVE : NEGATIVE}`

    return null
}
